module.exports =
  shipping:
    shortShip: '/packingSlip/shipping/shortShip.pdf'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/packingSlip.coffee